import PropTypes from 'prop-types';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import { Link } from 'react-router';
import config from 'cfg';
import auth from 'dash-front/auth';
import TemplateCard from './TemplateCard';
import DialogImport from './DialogImport';

class TemplatesList extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            templates: [],
            showHidden: this.props.route.params.isHidden || false,
            openImportDialog: false,
            openCloneDialog: false,
            errorFieldClone: false,
            cloneTemplateName: '',
            cloneTemplateId: null,
        };

        this.loadData();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    loadData = additionalStateParams => {
        var user = this.context.user;

        if (!user || !user.client) return null;

        return fetch(`${config.dash.api.host}/api/templates?access_token=${auth.getAccessToken()}`)
            .then(response => response.json())
            .then(templates => {
                this.setState({
                    templates,
                    isLoading: false,
                    ...additionalStateParams
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    error: e,
                    isLoading: false,
                    ...additionalStateParams
                });
            });
    };

    handleTemplatesHide = (id) => {
        id = encodeURIComponent(id);

        fetch(`${config.dash.api.host}/api/templates/${id}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                isHidden: !_.find(this.state.templates, ['id', id]).isHidden
            })
        }).then(response => {
            if (response.status === 200) {
                this.loadData();
            }
        });
    };

    handleTemplatesClone = () => {
        const {cloneTemplateName, errorFieldClone, cloneTemplateId} = this.state;
        const id = encodeURIComponent(cloneTemplateId);

        if (cloneTemplateName) {
            fetch(`${config.dash.api.host}/api/templates/${id}/clone?templateName=${cloneTemplateName}`, {
                method: 'POST',
                headers: {
                    authorization: auth.getAccessToken()
                }
            })
            .then(({status}) => {
                if (status === 200) {
                    this.loadData();
                } else {
                    throw new Error(`Error load status: ${status}`);
                }

                this.handleDialogClose('openCloneDialog')();
            })
            .catch(err => {
                console.error(err);
            });
        } else {
            this.setState({
                errorFieldClone: !cloneTemplateName ? true : errorFieldClone,
            });
        };
    };

    handleDialogOpen = (type, payload = {}) => (ev) => {
        if (ev) ev.preventDefault();

        this.setState({
            [type]: true
        });

        if (payload.cloneTemplateId) this.setState({ cloneTemplateId: payload.cloneTemplateId });
    };

    handleDialogClose = (type, payload = {}) => (ev) => {
        if (ev) ev.preventDefault();

        this.setState({
            [type]: false
        });

        if (type === 'openCloneDialog') this.setState({ cloneTemplateName: '', errorFieldClone: false });
    }

    render() {
        let { templates, openImportDialog, openCloneDialog, errorFieldClone, cloneTemplateName } = this.state;
        const noTemplates = _.isEmpty(templates);
        const hiddenTemplatesExist = templates.some(t => t.isHidden);
        const hiddenFilterLabel = this.state.showHidden ? 'Show active templates' : 'Show hidden templates';

        return (
            <div className="pick-theme">
                <div className="row">
                    <div className="col-xs-6">
                        <rmd.Subheader>
                            {noTemplates ? 'Create your first template!' : 'Choose existing template or'}{' '}
                            <Link onClick={window.location.reload} to="/sm/templates/create">
                                create new
                            </Link>
                            {' '}or{' '}
                            <a onClick={this.handleDialogOpen('openImportDialog')} href=''>
                                import template
                            </a>
                        </rmd.Subheader>
                    </div>
                    <div className="col-xs-6" style={{ textAlign: 'right' }}>
                        {hiddenTemplatesExist && 
                            <rmd.Subheader>
                                <Link href={this.state.showHidden ? '/sm/templates' : '/sm/templates/hidden'}>{hiddenFilterLabel}</Link>
                            </rmd.Subheader>}
                    </div>
                </div>

                <div className="row">
                    <ReactCSSTransitionGroup transitionName="rlzFadeAnimation" transitionEnterTimeout={500} transitionLeave={false}>                
                        {templates.filter(t => (this.state.showHidden ? t.isHidden : !t.isHidden)).map((template, i) => {
                            return (
                                <div className="col-xs-12 col-sm-6 col-md-4" key={template.id}>
                                    <div className="theme-template-wrapper">
                                        <TemplateCard template={template} handleTemplatesHide={this.handleTemplatesHide} handleTemplatesClone={this.handleTemplatesClone} handleDialogOpen={this.handleDialogOpen} />
                                    </div>
                                </div>
                            );
                        })}
                    </ReactCSSTransitionGroup>
                </div>
                <DialogImport 
                    show={openImportDialog}
                    dialogTitle='Import template'
                    submitCb={this.loadData}
                    urlSubmit={`${config.dash.api.host}/api/templates/import`}
                    closeCb={this.handleDialogClose('openImportDialog')}
                />
                <rmd.Dialog
                    title={'Clone template name'}
                    modal={false}
                    open={openCloneDialog}
                    onRequestClose={this.handleDialogClose('openCloneDialog')}
                    actions={_.compact([
                        <rmd.FlatButton label="Close" onClick={this.handleDialogClose('openCloneDialog')} />,
                        <rmd.FlatButton
                            primary
                            label={'Clone'}
                            onClick={this.handleTemplatesClone}
                        />
                    ])}
                >
                    <rmd.TextField
                        fullWidth
                        floatingLabelText={'Template name'}
                        errorText={errorFieldClone ? 'This field is required' : ''}
                        name={cloneTemplateName}
                        onChange={(e, cloneTemplateName) => {
                            if (errorFieldClone && cloneTemplateName.length) this.setState({ errorField: false });
                            this.setState({ cloneTemplateName });
                        }}
                    />
                </rmd.Dialog>
            </div>
        );
    }
}

export default TemplatesList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/TemplatesList.js
 **/